module.exports = __webpack_public_path__ + "static/Podcast03-de5ac79f837ff2232bcbeea0f4bcb9d8.jpg";